import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { rememberTarget } from "@/lib/returnPath";
import { useMemberAuth } from "../MemberAuthContext";
import { MemberLayout } from "./MemberLayout";

export default function MemberProtectedRoute() {
  const { member, ended } = useMemberAuth();
  const { pathname } = useLocation();
  if (member === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#FBF6FA]">
        <Loader2 className="h-8 w-8 animate-spin text-brand-magenta" aria-label="Wird geladen" />
      </div>
    );
  }
  if (!member) {
    // Only a validated internal path travels in router memory; never in the URL, never after a session end.
    const from = rememberTarget(ended, pathname);
    return <Navigate to="/login" replace state={from ? { from } : null} />;
  }
  return (
    <MemberLayout>
      <Outlet />
    </MemberLayout>
  );
}
